export default "__VITE_ASSET__d2ee4cb7__"